'use client';

import { atom } from 'jotai';

export const latestNlsQueryAtom = atom<string | null>(null);
